import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { redeemAuthToken } from './actions'
import { ensureMeta } from '../../shared/actions/meta';
import Field from '../../shared/components/fields/Inputs';
import checkmark from '../../shared/images/checkmark.svg';

// {host}/locate/by-collection/{collectionId}

class LocateByToken extends Component {
    state = {
        secret: this.props.match.params.secret,
        errors: []
    };

    infos = ["Click Submit after entering your access code."];

    componentWillMount() {
        this.props.dispatch(ensureMeta(this.props.match.params.collectionId))
    }

    componentWillReceiveProps(props) {
        if (props.failureReason) {
            let errors = [...this.state.errors];
            errors.push(props.failureReason);
            this.setState({
                errors: errors
            });
            this.input.focus();
        }
    }

    handleOnSubmit = (e) => {
        e.preventDefault();
        let errors = this.input.validate(this.state.secret);
        if (errors && errors.length > 0){
            this.setState({
                errors: errors
            });
            this.input.focus();
        } else {
            this.props.dispatch(redeemAuthToken(this.props.match.params.authToken, this.state.secret));
        }
    }

    handleOnChange = (data) => {
        let errors = this.input.validate(data.secret);
        if (errors && errors.length > 0) {
            this.setState({
                'errors': errors
            });
            this.input.focus();
        } else {
            this.setState({
                errors: errors,
                secret: data.secret
            });
        }
    }

    componentDidMount() {
        if (this.input)
            this.input.focus();
    }

    cb = null

    cacheBust(url) {
        if (!this.cb)
            this.cb = new Date().valueOf().toString();

        return url + '?cb=' + this.cb;
    }

    secretFieldDef = {
        'key': 'secret',
        'label': 'Access code',
        'dataType': 'STRING',
        'defaultValue': '',
        'isRequired': true,
        'validators': [],
        'valueHint': 'Copy & paste the code from your email'
    }

    render() {
        if (this.props.authorizedCollectionId){
            const target = '/app/record/find/' + this.props.authorizedCollectionId;
            return <Redirect to={target} />
        }


        //const { match: { params: { recordDefinitionKey }}} = this.props;
        return (<div className="ac-wizard">
                <div className="ac-wizard-header">
                    <h2>Please check your email</h2>
                </div>
                <div className="ac-wizard-body">
                    <div className="ac-iconned">
                        <div className="ac-icon-container-left">
                            <img className="ac-icon-med" src={this.cacheBust(checkmark)} />
                        </div>
                        <div>
                            <p>We emailed you an access code to complete this form. If it's not used within 1 hour, a new code will need to be requested.</p>
                            <p>Please find the code in your email then copy &amp; paste it below.</p>
                            <p><b>Note:</b> Check your SPAM folder if the message doesn't arrive shortly.<br />Email Chad Boschert at <a href="mailto:chad@aptcrowd.co">chad@aptcrowd.co</a> if you have any issues.</p>
                        </div>
                    </div>
                    <Field key="secret" value={this.state.secret} errors={this.state.errors} infos={this.infos} fieldDef={this.secretFieldDef} onValueChanged={this.handleOnChange} ref={(me) => this.input = me} />
                </div>
                <div className="ac-wizard-nav">
                    <span>{this.props.emailedTo ? "We sent an email to " + this.props.emailedTo : ""}</span>
                    <input type="submit" className="ac-btn ac-btn-primary" value="Submit" onClick={this.handleOnSubmit} ref={(o) => this.submit = o}/>
                </div>
            </div>);
    }
}

function mapStateToProps(state) {
    return {
        authorizedCollectionId: state.components.locate.authorizedCollectionId,
        failureReason: state.components.locate.failureReason,
        emailedTo: state.components.locate.emailedTo
    };
}

export default connect(mapStateToProps)(LocateByToken);